
/*
  TikTok Slider
*/
const initTikTokSlider = () => {
  document.querySelectorAll('.tiktok-slider').forEach(section => {
    const element = section.querySelector('.splide')

    const mySplide = new Splide(element, {
      arrows: element.dataset.arrows === 'true',
      pagination: false,
      easing: element.dataset.easing,
      perMove: Number(element.dataset.perMove),
      autoplay: element.dataset.autoplay === 'true',
      interval: Number(element.dataset.interval),
      per_move: Number(element.dataset.perMove),
      rewind: element.dataset.rewind === 'true',
      gap: Number(element.dataset.gap),
      mediaQuery: 'min',
      breakpoints: {
        0: { perPage: Number(element.dataset.breakpointXs), padding: '15%' },
        576: { perPage: Number(element.dataset.breakpointSm), padding: 0 },
        768: { perPage: Number(element.dataset.breakpointMd), padding: 0 },
        992: { perPage: Number(element.dataset.breakpointLg), padding: 0 },
        1200: { perPage: Number(element.dataset.breakpointXl), padding: 0 },
        1400: { perPage: Number(element.dataset.breakpointXxl), padding: 0 }
      },
      direction: document.documentElement.getAttribute('dir')
    })
    mySplide.mount()

    section.querySelectorAll('video').forEach(video => {
      const videoWrapper = video.closest('.video-wrapper')
      const soundBtn = videoWrapper.querySelector('[data-toggle-sound]')

      video.addEventListener('click', (e) => {
        section.querySelectorAll(`video:not([data-index="${video.dataset.index}"])`).forEach(video => {
          video.pause()
          video.closest('.video-wrapper').classList.remove('is-playing')
        })

        if (videoWrapper.classList.contains('is-playing')) {
          video.pause()
          videoWrapper.classList.remove('is-playing')
        } else {
          video.play()
          videoWrapper.classList.add('is-playing')

          if (section.dataset.volume === 'on') {
            video.muted = false
            soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
            soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
          }
        }
      })

      soundBtn?.addEventListener('click', () => {
        video.muted = !video.muted

        if (video.muted) {
          soundBtn.querySelector('.icon-volume-off').removeAttribute('hidden')
          soundBtn.querySelector('.icon-volume-on').setAttribute('hidden', 'hidden')
          section.setAttribute('data-volume', 'off')
        } else {
          soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
          soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
          section.setAttribute('data-volume', 'on')
        }
      })
    })

    mySplide.on('moved', (newIndex, prevIndex) => {
      const video = section.querySelector(`video[data-index="${newIndex}"]`)
      const videoWrapper = video.closest('.video-wrapper')
      const soundBtn = videoWrapper.querySelector('[data-toggle-sound]')

      if (video) {
        section.querySelectorAll(`video:not([data-index="${newIndex}"])`).forEach(video => {
          video.muted = true
          video.pause()
          video.closest('.video-wrapper').classList.remove('is-playing')
        })

        video.play()

        videoWrapper.classList.add('is-playing')

        if (section.dataset.volume === 'on' && !navigator.userAgent.match(/(iPad|iPhone)/g)) {
          video.muted = false
          soundBtn.querySelector('.icon-volume-off').setAttribute('hidden', 'hidden')
          soundBtn.querySelector('.icon-volume-on').removeAttribute('hidden')
        }
      }
    })
  })
}
initTikTokSlider()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.tiktok-slider')) {
    initTikTokSlider()
  }
})